import { FranchiseMaster } from './FranchiseMaster.model';
import { PredefinedMaster } from './PredefinedMaster.model';
import { CourseMaster } from './CourseMaster.model';
import { StudentLectureMaster } from './StudentLectureMaster.model';
import { User } from './User.model';

export class StudentMaster{
    public studentMasterId:number
    public name:String;
    public contactNo:number;
    public email:string;
    public password:String;
    public user:User;
    public referralCode:string;
    public confirmPassword:String;
    public franchiseMaster:FranchiseMaster;
    public location:PredefinedMaster;
    public defaultEnrollCourseMasterId:number;
    public desiredCourseMaster:CourseMaster;
    public studentName:String;
    public studentDob:Date;
    public defaultStudentLectureMaster:StudentLectureMaster;
    public subName:string;
    public state:PredefinedMaster;
    public referralCodeUsedInRegistration:string;

}   